'use client'

import { useTranslation } from 'react-i18next'
import LogoGradient from '@/components/styled/LogoGradient'
import GradientSection from '@/components/styled/GradientsSection'
import DarkGradientSection from '@/components/styled/DarkGradientSection'
import AppleButton from '@/components/common/AppleButton'
import GoogleButton from '@/components/common/GoogleButton'

const HeroSection = () => {
  const { t } = useTranslation('home')

  return (
    <>
      <section className="hidden dark:flex flex-col">
        <DarkGradientSection>
          <div className="mt-[164px] sm:mt-[140px] mx-auto flex flex-col">
            <h2 className="text-[23px] sm:text-[48px] tracking-[-0.05em] sm:text-main-light-2 dark:text-main-dark-2 mx-auto leading-tight">
              {t('hero_text_1')}
            </h2>
            <h2 className="text-[23px] sm:text-[48px] tracking-[-0.05em] sm:text-main-light-2 dark:text-main-dark-2 mx-auto leading-tight">
              {t('hero_text_2')}
            </h2>
          </div>
          <div className="relative sm:mt-[51px] mx-auto w-[80%] sm:w-full h-[150px] sm:h-[206px] overflow-hidden">
            <LogoGradient
              style={{
                backgroundImage: `url('/images/GradientBackground.png')`
              }}
            />
          </div>
          <div className="flex flex-col sm:flex-row justify-center items-center gap-3 sm:gap-4 sm:mt-[54px] mb-[90px] sm:mb-[220px]">
            <AppleButton />
            <GoogleButton />
          </div>
        </DarkGradientSection>
      </section>

      <section className="flex flex-col dark:hidden">
        <GradientSection>
          <div className="mt-[164px] sm:mt-[140px] mx-auto flex flex-col">
            <h2 className="text-[23px] sm:text-[48px] tracking-[-0.05em] sm:text-main-light-2 dark:text-main-dark-2 mx-auto leading-tight">
              {t('hero_text_1')}
            </h2>
            <h2 className="text-[23px] sm:text-[48px] tracking-[-0.05em] sm:text-main-light-2 dark:text-main-dark-2 mx-auto leading-tight">
              {t('hero_text_2')}
            </h2>
          </div>
          <div className="relative sm:mt-[51px] mx-auto w-[80%] sm:w-full h-[150px] sm:h-[206px] overflow-hidden">
            <LogoGradient
              style={{
                backgroundImage: `url('/images/GradientBackground.png')`
              }}
            />
          </div>
          <div className="flex flex-col sm:flex-row justify-center items-center gap-3 sm:gap-4 sm:mt-[54px] mb-[90px] sm:mb-[220px]">
            <AppleButton />
            <GoogleButton />
          </div>
        </GradientSection>
      </section>
    </>
  )
}

export default HeroSection
